import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import CircleIcon from "@mui/icons-material/Circle";

function OurStory() {
  return (
    <Grid container padding={{ xs: "25% 0%", sm: "8% 0%" }}>
      <Grid items sm={7.8} xs={12} display={{ xs: "none", sm: "block" }}>
        <Box width={"100%"}>
          <Typography
            variant="h6"
            color="#33E68C"
            paddingBottom={"1%"}
            textAlign={"left"}
            data-aos={"fade-up"}
          >
            The Story
          </Typography>
          <Divider color={"#bbb"} width={"90%"} />
          <Typography
            variant="h3"
            color="#bbb"
            textAlign={"left"}
            paddingTop={"5%"}
            data-aos={"fade-up"}
          >
            OnDesign is a digital agency that offers a wide scale of creative
            services, including brand development, web development and lots
            more.
          </Typography>
        </Box>
      </Grid>
      <Grid items sm={8} xs={12} display={{ xs: "block", sm: "none" }}>
        <Box width={"100%"}>
          <Typography
            variant="h6"
            color="#33E68C"
            paddingBottom={"1%"}
            textAlign={"left"}
            display={{ xs: "inline", sm: "block" }}
            data-aos={"fade-up"}
          >
            The Story
          </Typography>
          <Divider color={"#bbb"} width={"90%"} />
          <Typography
            variant="h4"
            color="#bbb"
            textAlign={"left"}
            paddingTop={"5%"}
            data-aos={"fade-up"}
          >
            OnDesign is a digital agency that offers a wide scale of creative
            services, including brand development, web development and lots
            more.
          </Typography>
        </Box>
      </Grid>
      <Grid items sm={4} xs={12} marginTop={{ xs: "25%", sm: "0%" }}>
        <Typography variant="h6" color="#33E68C" paddingBottom={"1%"}>
          Our Services Include;
        </Typography>
        <Divider color={"#bbb"} width={"80%"} />
        <Box
          display="flex"
          flexWrap={"wrap"}
          flexDirection={"column"}
          paddingTop={"10%"}
          data-aos={"fade-up"}
        >
          <Typography
            color="#bbb"
            variant={"body1"}
            fontWeight={700}
            paddingBottom={{ xs: "5%", sm: "9%" }}
            sx={{
              "&:hover": {
                color: "#fff",
              },
            }}
          >
            <CircleIcon
              sx={{
                color: "#33E68C",
                width: 15,
                height: 15,
                "&:hover": {
                  color: "#fff",
                },
              }}
            />{" "}
            Web Development
          </Typography>
          <Typography
            color="#bbb"
            variant={"body1"}
            fontWeight={700}
            paddingBottom={{ xs: "5%", sm: "9%" }}
            sx={{
              "&:hover": {
                color: "#fff",
              },
            }}
          >
            <CircleIcon
              sx={{
                color: "#33E68C",
                width: 15,
                height: 15,
                "&:hover": {
                  color: "#fff",
                },
              }}
            />{" "}
            Mobile App Development
          </Typography>
          <Typography
            color="#bbb"
            variant={"body1"}
            fontWeight={700}
            paddingBottom={{ xs: "5%", sm: "9%" }}
            sx={{
              "&:hover": {
                color: "#fff",
              },
            }}
          >
            <CircleIcon
              sx={{
                color: "#33E68C",
                width: 15,
                height: 15,
                "&:hover": {
                  color: "#fff",
                },
              }}
            />{" "}
            Full Services Branding
          </Typography>
          <Typography
            color="#bbb"
            variant={"body1"}
            fontWeight={700}
            paddingBottom={{ xs: "5%", sm: "9%" }}
            sx={{
              "&:hover": {
                color: "#fff",
              },
            }}
          >
            <CircleIcon
              sx={{
                color: "#33E68C",
                width: 15,
                height: 15,
                "&:hover": {
                  color: "#fff",
                },
              }}
            />{" "}
            Document Design & Printing
          </Typography>
          <Typography
            color="#bbb"
            variant={"body1"}
            fontWeight={700}
            paddingBottom={{ xs: "5%", sm: "9%" }}
            sx={{
              "&:hover": {
                color: "#fff",
              },
            }}
          >
            <CircleIcon
              sx={{
                color: "#33E68C",
                width: 15,
                height: 15,
                "&:hover": {
                  color: "#fff",
                },
              }}
            />{" "}
            Data Analysis & Survey
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
}

export default OurStory;
